// src/components/Navbar.js
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Layout, Menu } from 'antd';
import {
  HomeOutlined,
  AppstoreOutlined,
  InfoCircleOutlined,
  PhoneOutlined,
  ShopOutlined,
  CoffeeOutlined,
  MenuOutlined,
  GlobalOutlined,
} from '@ant-design/icons';
import { image } from '../data/homeContent';
import { useCurrency } from '../context/CurrencyContext';

const { Header } = Layout;

const menuItems = [
  { key: 'home', icon: <HomeOutlined />, label: <Link to="/">Home</Link> },
  { key: 'features', icon: <AppstoreOutlined />, label: <Link to="/features">Features</Link> },
  { key: 'hospitality', icon: <CoffeeOutlined />, label: <Link to="/hospitality">Hospitality</Link> },
  { key: 'retail', icon: <ShopOutlined />, label: <Link to="/retail">Retail</Link> },
  { key: 'about', icon: <InfoCircleOutlined />, label: <Link to="/about">About Us</Link> },
  { key: 'contact', icon: <PhoneOutlined />, label: <Link to="/contact">Contact Us</Link> },
];

const pathToKey = {
  '/': 'home',
  '/features': 'features',
  '/hospitality': 'hospitality',
  '/retail': 'retail',
  '/about': 'about',
  '/contact': 'contact',
};

const Navbar = () => {
  const { currency, changeCurrency } = useCurrency();
  const location = useLocation();
  const excludedPaths = ['/privacy-policy', '/terms-of-service'];
  const selectedKey = excludedPaths.includes(location.pathname)
    ? null
    : (pathToKey[location.pathname] || 'home');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <Header className="sticky top-0 z-50 backdrop-blur-md bg-white/75 border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo/Brand */}
          <div className="flex-shrink-0 flex items-center space-x-3">

            <img
              src={image.logo} // Place your icon image in public/logo-icon.png or adjust the path accordingly
              alt="SnapPOS Logo Icon"
              className="w-45 h-15"
            />

          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-4">
            <Menu
              mode="horizontal"
              selectedKeys={selectedKey ? [selectedKey] : []}
              items={menuItems}
              className="modern-navbar-menu border-none bg-transparent"
              style={{
                fontWeight: 500,
                fontSize: '1rem',
                color: '#51dcb1',
                minWidth: '500px'
              }}
            />
            {/* Currency Dropdown Desktop */}
            <div className="flex items-center bg-gray-50 rounded-full px-3 py-1 border border-gray-100 hover:border-[#51dcb1] transition-all">
              <GlobalOutlined className="text-[#51dcb1] mr-2" />
              <select
                value={currency}
                onChange={(e) => changeCurrency(e.target.value)}
                className="bg-transparent text-sm font-semibold text-gray-700 outline-none cursor-pointer"
              >
                <option value="GBP">Pound (£)</option>
                <option value="INR">INR (₹)</option>
              </select>
            </div>
          </div>

          {/* Mobile Menu Button & Currency Dropdown Mobile */}
          <div className="md:hidden flex items-center space-x-3">
            <select
              value={currency}
              onChange={(e) => changeCurrency(e.target.value)}
              className="bg-gray-50 text-xs font-bold text-[#51dcb1] border border-gray-100 rounded-md px-1 py-1 outline-none"
            >
              <option value="GBP">£</option>
              <option value="INR">₹</option>
            </select>
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-[#51dcb1] hover:text-white hover:bg-[#51dcb1]/80 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-[#51dcb1]"
            >
              <MenuOutlined className="h-6 w-6" />
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`md:hidden ${isMobileMenuOpen ? 'block' : 'hidden'}`}>
        <Menu
          mode="inline"
          selectedKeys={selectedKey ? [selectedKey] : []}
          items={menuItems}
          className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white-500"
          style={{
            color: '#51dcb1',
          }}
        />
      </div>
    </Header>
  );
};

export default Navbar;
